// extracted by mini-css-extract-plugin
module.exports = {"saucedSheeeshContainer":"SaucedSheeesh_saucedSheeeshContainer__1FUdt"};